import React, { memo, useCallback } from 'react';
import type { ISidebarProps, SectionId } from '../types';
import { useNavigate } from 'react-router-dom';

// Movendo navItems para fora do componente para evitar recriação
const navItems: { id: SectionId; title: string; icon: string }[] = [
    { id: 'dashboard', title: 'Dashboard', icon: 'ph-squares-four' },
    { id: 'analysis', title: 'Análise IA', icon: 'ph-brain' },
    { id: 'artists', title: 'Artistas', icon: 'ph-users-three' },
    { id: 'agenda', title: 'Agenda', icon: 'ph-calendar' },
    { id: 'workflow', title: 'Workflow', icon: 'ph-calendar-check' },
];

export const Sidebar = memo(({ activeSection }: ISidebarProps) => {
    const navigate = useNavigate();
    const handleNavClick = useCallback((e: React.MouseEvent<HTMLButtonElement>, targetId: SectionId) => {
        e.preventDefault();
        const to: Record<SectionId, string> = {
            dashboard: '/',
            analysis: '/analytics',
            artists: '/artists',
            agenda: '/agenda',
            workflow: '/workflow',
        };
        navigate(to[targetId] || '/');
    }, [navigate]);

    const navItemsToRender = navItems;

    return (
        <aside className="hidden lg:flex flex-col shrink-0 side-nav w-56 p-3">
            <nav className="flex-grow">
                <ul className="space-y-1.5">
                    {navItemsToRender.map((item) => (
                        <li key={item.id}>
                            <button
                                type="button"
                                aria-label={item.title}
                                onClick={(e) => handleNavClick(e, item.id)}
                                className={`side-item ${activeSection === item.id ? 'active' : ''}`}
                            >
                                <i className={`ph ${item.icon} text-lg`}></i>
                                <span className="truncate">{item.title}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    );
});

